
import {map, take} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ApiService } from '../../shared/api.service';

@Injectable()
export class DayService {

  constructor(private http: HttpClient,
              private apiService: ApiService) {}

  public getHLS(filter) : Observable<any> {
    return this.http.post(this.apiService.getHLS(), filter).pipe(take(1),map(value => {
      return value;
    }),);
  }
}
